/** Brief title + class flash on a button after a successful clipboard copy. */
export function flashCopyOnButton(
  btn: HTMLButtonElement,
  message = 'Copied to clipboard',
  ms = 2000
): void {
  const prevTitle = btn.title;
  btn.title = message;
  btn.classList.add('btn-copy-flash');
  window.setTimeout(() => {
    btn.title = prevTitle;
    btn.classList.remove('btn-copy-flash');
  }, ms);
}
